import React from "react";
import "../css/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* COMPANY INFO */}
        <div className="footer-col">
          <h3>OUR COMPANY</h3>
          <p className="company-name">SKT Construction</p>
          <p>
            At SKT Construction, we deliver complete solutions for the construction industry by combining expert building services with reliable machinery rentals. Our team is dedicated to quality, efficiency, and innovation, ensuring that every project is handled with professionalism and care. 
          </p>
        </div>

        {/* CONTACT INFO */}
        <div className="footer-col">
          <h3>CONTACT INFORMATION</h3>
          <p>📞 Phone: +91 9244202021</p>
          <p>✉️ Mail: management@sktconstructions.in</p>
          <p>📍 Address: Singra Mau, PO, Sahson, Uttar Pradesh , 221507</p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h3>QUICK LINKS</h3>
          <a href="/">Home</a>
          <a href="#">Services</a>
          <a href="/about">About Us</a>
          <a href="#">Blog</a>
          <a href="#">Contact</a>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="social-icons">
          <span>🌐</span>
          <span>🐦</span>
          <span>📸</span>
          <span>▶️</span>
        </div>

        <p>
          © 2021 SKT Construction | Privacy Policy | Terms & Condition | FAQ
        </p>
      </div>
    </footer>
  );
}
